module.exports = __webpack_public_path__ + "img/27_36.4b9d0133.png";